import {DropDownModel} from "../common/models/dropDown";

export class DropDownUtils {
    public static listToDropDownMap(list: any[], id = "id", name = "name", getNameMethod?: (element: any) => string, parentElementHasIdAndName?: boolean): DropDownModel[] {
        if (!list || (list && typeof list.map !== "function")) {
            return [];
        }

        if (getNameMethod) {
            if (parentElementHasIdAndName) {
                return list.map((item) => ({id: item, name: getNameMethod(item)}));
            } else {
                return list.map((item) => ({id: item[id], name: getNameMethod(item[name])}));
            }
        }

        return list.map((item) => ({id: item[id], name: item[name]}));
    }
}
